module.exports = __webpack_public_path__ + "static/media/RubyTest.def04ef4.pdf";